var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureTimezone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1867_5411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0481 7.71094C15.3915 12.229 14.4878 71.8673 42.048 77.289",
    stroke: "#2C3549",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9517 77.2888C69.6083 72.7708 70.512 13.1325 42.9517 7.7108",
    stroke: "#2C3549",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4999 5L42.4995 80",
    stroke: "#2C3549",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.4998,
    cy: 42.4998,
    r: 35.4998,
    stroke: "#2C3549",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.0364,
    y1: 21.5244,
    x2: 71.8675,
    y2: 21.5244,
    stroke: "#2C3549",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.0364,
    y1: 63.0898,
    x2: 71.8675,
    y2: 63.0898,
    stroke: "#2C3549",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.90369,
    y1: 42.3071,
    x2: 78.1925,
    y2: 42.3071,
    stroke: "#2C3549",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 66,
    r: 21,
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 65C73.5523 65 74 65.4477 74 66L74 68C74 68.5523 73.5523 69 73 69L63 69L63 65L73 65Z",
    fill: "#06ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 57C63 56.4477 63.4477 56 64 56H66C66.5523 56 67 56.4477 67 57V69H63V57Z",
    fill: "#06ADEF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 17,
    stroke: "#06ADEF",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1867_5411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTimezone);
export default __webpack_public_path__ + "static/media/feature-timezone.c6c7a92b.svg";
export { ForwardRef as ReactComponent };